import { call, put, select } from 'redux-saga/effects';
import * as pageStateService from '../page-state/page-state.saga-services';
import * as actions from './transcripts.actions';
import * as transcriptService from '../../resource/session-transcript/session-transcripts.saga-service';
import * as transcriptSummaryService from '../../resource/session-transcript-summary/session-transcript-summary.saga-service';
import * as transcriptSummaryActions from '../../resource/session-transcript-summary/session-transcript-summary.actions';
import { ISession } from '../../resource/session/session.types';
import { IFetchSessionTranscriptActionParams } from './transcripts.types';
import { transcriptPageSelectors } from './transcripts.selectors';
import { ISessionTranscriptSummary } from '../../resource/session-transcript-summary/session-transcript-summary.types';

export function* fetchSessionTranscripts(sessionId: ISession['id'], params?: IFetchSessionTranscriptActionParams) {
  const transcript = yield select(transcriptPageSelectors.selectSessionTranscriptsBySessionId, sessionId);

  const oldContent = transcript ? transcript.content : [];
  yield call(pageStateService.initPage, 'sessionTranscripts');
  const meetingTranscript = yield call(transcriptService.fetchSessionTranscripts, sessionId, params);
  const fetchedContent = meetingTranscript ? meetingTranscript.content : null;
  const newContent = [...oldContent, ...fetchedContent];
  yield put(actions.storeSessionTranscript({ [sessionId]: { ...meetingTranscript, content: newContent } }));
  yield call(pageStateService.completedInit, 'sessionTranscripts');
}

export function* clearSessionTranscript() {
  yield call(actions.clearSessionTranscript);
}

export function* fetchSessionTranscriptSummary(sessionId: ISession['id']): Generator<unknown, void, unknown> {
  try {
    const transcriptSummary = (yield call(
      transcriptSummaryService.fetchSessionTranscriptSummary,
      sessionId,
    )) as ISessionTranscriptSummary;
    if (transcriptSummary) {
      yield put(transcriptSummaryActions.storeSessionTranscriptSummary(transcriptSummary));
    }
  } catch (error) {
    console.error('Failed to fetch transcript summary:', error);
  }
}
